import {
  addHtmlElementClass, addHtmlElementEventListener, AUTOSAVING_ACCEPTED_KEY_FOR_LOCAL_STORAGE,
  removeHtmlElementClass,
  renderWebComponent, setHtmlElementContent, veryVeryHighDebouncedFunction
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import { EventBusComponent } from "../EventBusComponent";
import I18n from "i18n-js";

const genericSuccessMessage = I18n.t('js.common.successMessage')

export class SuccessFlashMessageComponent extends HTMLElement {
  eventBus = null;

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
    this.render();
  }

  connectedCallback() {
    this.eventBus.subscribe('render-new-success-flash-message', (type, message) => {
      this.setMessage(this.shadowRoot, type, message, true);
      veryVeryHighDebouncedFunction(this.setMessage, [this.shadowRoot, null, null, false]);
    });

    addHtmlElementEventListener(this.shadowRoot, 'question_success_icon', 'click', (e) => {
      window.localStorage.setItem(AUTOSAVING_ACCEPTED_KEY_FOR_LOCAL_STORAGE, JSON.stringify(true))
      this.eventBus.publish('render-modal', {
        title: I18n.t('js.editSubmissionListPage.webComponent.autosaving_banner.title'),
        body: [
          I18n.t('js.editSubmissionListPage.webComponent.autosaving_banner.txt1'),
          I18n.t('js.editSubmissionListPage.webComponent.autosaving_banner.txt2')
        ],
        confirmTxt: I18n.t('js.editSubmissionListPage.webComponent.autosaving_banner.button')
      })
      }
    )
  }

  setMessage(root, type, newMessage, display) {
    if (display) {
      if (type === 'message') {
        setHtmlElementContent(root, "success_message", newMessage ? newMessage : genericSuccessMessage);
        removeHtmlElementClass(root, "success_message", "d-none");
      }
      else {
        var autosavingAccepted = window.localStorage.getItem(AUTOSAVING_ACCEPTED_KEY_FOR_LOCAL_STORAGE);
        removeHtmlElementClass(root, autosavingAccepted ? 'success_icon' : 'question_success_icon', "d-none");
      }
    }
    else {
      addHtmlElementClass(root, "success_message", "d-none");
      addHtmlElementClass(root, "success_icon", "d-none");
      addHtmlElementClass(root, "question_success_icon", "d-none");
    }
  }


  render() {
    const html = `
      <div class="success-flash-message text-center z-index-125 d-none" id="success_message">
        ${genericSuccessMessage}
      </div> 
      
      <div class="success-flash-icon bg-transparent-imp p-2 text-center z-index-125 d-none" id="success_icon">
        <img src="/images/icons/cloud.svg" 
          alt=""
        >
      </div>  
      
      <div class="success-flash-icon bg-transparent-imp p-2 text-center z-index-125 d-none cursor-pointer" id="question_success_icon">
        <img src="/images/icons/question_cloud.svg" 
          alt=""
        >
      </div>  
    `

  renderWebComponent(html, this.shadowRoot, [commonStyles]);
  }
}

window.customElements.define("success-flash-message-component", SuccessFlashMessageComponent);